import {Dictionary} from "../model/dictionary";
import {SearchItem} from "../model/search-item";
import {NgbDate} from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date";

export class AbstractReport  {

  hasRightsForFilterSelected: Array<Boolean> = [];
  searchItems: Array<SearchItem> = [];
  contentTypeForFilterSelected: Array<Dictionary> = [];
  fileFormatsForFilterSelected: Array<string> = [];
  thematicsProductsForFilterSelected: Array<Dictionary> = [];
  thematicsInstitutionForFilterSelected: Array<Dictionary> = [];
  thematicsClientGroupsForFilterSelected: Array<Dictionary> = [];
  contentTypeSelected: Dictionary = AbstractReport.homeMenuContent;
  thematicsAreaForFilterSelected: Array<Dictionary> = [];
  thematicsFrequenciesForFilterSelected: Array<Dictionary> = [];
  dateFromFilter: NgbDate;
  dateToFilter: NgbDate;
  dateFrom: Date;
  dateTo: Date;
  countedReports: number;

  //Sortowania
  orderByField: string = "publishFrom";
  orderAsc: boolean = false;

  static readonly homeMenuContent: Dictionary = {
    id: null,
    value: "Raporty",
    value_1: "",
    enabled: true,
    dictId: 999
  };


  /**
   * Buduje obiekt z danymi do filtra.
   * @param fromSearchBox czy ma uwzględnić parametry wpisane w searchBox na stronie
   * @private
   */
  buildFilterParams(fromSearchBox: boolean = false): Object {
    let filterParams = {};
    let thematics_client_groups_search_items: Array<number> = [];
    let thematics_products_search_items: Array<number> = [];
    let thematics_area_search_items: Array<number> = [];
    let thematics_institution_search_items: Array<number> = [];
    let content_type_search_items = 0;

    if (fromSearchBox) {
      filterParams['operation'] = 'search';
      if (this.searchItems.length > 0) {
        if (this.searchItems[0].custom) {
          filterParams['title'] = this.searchItems[0].value;
          filterParams['usertag'] = this.searchItems[0].value;
        } else {
          content_type_search_items = this.getSearchItems(filterParams, 'content_type')[0];
          thematics_client_groups_search_items = this.getSearchItems(filterParams, 'thematics_client_groups');
          thematics_products_search_items = this.getSearchItems(filterParams, 'thematics_products');
          thematics_area_search_items = this.getSearchItems(filterParams, 'thematics_area');
          thematics_institution_search_items = this.getSearchItems(filterParams, 'thematics_institution');
        }
      } else {
        filterParams['thematics_client_groups'] = null;
        filterParams['thematics_products'] = null;
        filterParams['thematics_area'] = null;
        filterParams['thematics_institution'] = null;
      }
    }

    let hasRightsFilterValue;
    if (this.hasRightsForFilterSelected.indexOf(true) !== -1 && this.hasRightsForFilterSelected.indexOf(false) !== -1) {
      hasRightsFilterValue = undefined;
    } else if (this.hasRightsForFilterSelected.indexOf(true) !== -1)
      hasRightsFilterValue = true;
    else if (this.hasRightsForFilterSelected.indexOf(false) !== -1)
      hasRightsFilterValue = false;

    if (hasRightsFilterValue !== undefined)
      filterParams['has_rights'] = hasRightsFilterValue;
    if (this.contentTypeSelected.id !== AbstractReport.homeMenuContent.id)
      filterParams['content_type'] = this.contentTypeSelected.id;
    else if (this.contentTypeForFilterSelected.length > 0)
      filterParams['content_type'] = this.contentTypeForFilterSelected.map(contentType => contentType.id);
    else if (content_type_search_items > 0)
      filterParams['content_type'] = content_type_search_items;
    filterParams['sortString'] = this.createSortString();
    if (this.fileFormatsForFilterSelected.length > 0)
      filterParams['fileFormat'] = this.fileFormatsForFilterSelected.toString();
    if (this.thematicsAreaForFilterSelected.length > 0 && thematics_area_search_items.length == 0)
      filterParams['thematics_area'] = this.thematicsAreaForFilterSelected.map((area: Dictionary) => area.id);
    if (this.thematicsClientGroupsForFilterSelected.length > 0 && thematics_client_groups_search_items.length == 0)
      filterParams['thematics_client_groups'] = this.thematicsClientGroupsForFilterSelected.map((clientGroup: Dictionary) => clientGroup.id);
    if (this.thematicsInstitutionForFilterSelected.length > 0 && thematics_institution_search_items.length == 0)
      filterParams['thematics_institution'] = this.thematicsInstitutionForFilterSelected.map((institution: Dictionary) => institution.id);

    if (this.thematicsProductsForFilterSelected.length > 0 && thematics_products_search_items.length == 0)
      filterParams['thematics_products'] = this.thematicsProductsForFilterSelected.map((product: Dictionary) => product.id);
    if (this.thematicsFrequenciesForFilterSelected.length > 0)
      filterParams['thematics_frequency'] = this.thematicsFrequenciesForFilterSelected.map((freq: Dictionary) => freq.id);

    const dateFrom = this.dateFromFilter ? new Date(this.dateFromFilter.year, this.dateFromFilter.month - 1, this.dateFromFilter.day) : null;
    const dateTo = this.dateToFilter ? new Date(this.dateToFilter.year, this.dateToFilter.month - 1, this.dateToFilter.day) : null;
    if (this.dateFromFilter) {
      filterParams['dateFrom'] = dateFrom;
      this.dateFrom = dateFrom;
    }
    if (this.dateToFilter) {
      filterParams['dateTo'] = dateTo;
      this.dateTo = dateTo;
    }

    return filterParams;
  }

  createSortString(): string {
    let sortString = '';
    if (this.orderAsc)
      sortString = this.orderByField.concat(" ASC");
    else
      sortString = this.orderByField.concat(" DESC");

    return sortString;
  }

  getSearchItems(filterParams, filterGroupName): Array<number> {
    let retVal: Array<number> = this.searchItems.filter((item: SearchItem) => {
      return (item.queryField == filterGroupName)
    }).map((item: SearchItem) => item.id);
    if (retVal.length > 0) {
      filterParams[filterGroupName] = retVal;
    }
    return retVal;
  }
}
